import { Modal, Row, Col } from "antd";
import { RelatorioAuditoriaQueryParams } from "core/features/relatorios/typings/index";
import Toolbar from "components/Toolbar/index";
import { Flex, Box, Text } from "@chakra-ui/react";
import { CloseModalButton } from "components/Button/CloseModalButton";
import FooterModal from "components/Button/FooterModal";
import { useState } from "react";
import { defaultFiltroRelatorioAuditoria } from "../../hooks/useFiltroRelatorioAuditoria";
import DateRangePicker from "components/Input/DateRangePicker";
import SelectTenant from "components/Input/SelectTenant";
import SelectUsuarioResponsavel from "components/Input/SelectUsuarioResponsavel";

interface ModalFiltroAuditoriaProps {
  visible: boolean;
  onClose: () => any;
  onReset: () => void;
  filtro: RelatorioAuditoriaQueryParams;
  onChangeFiltro: (_filtro: Partial<RelatorioAuditoriaQueryParams>) => void;
}

export default function ModalFiltroAuditoria({
  filtro,
  onChangeFiltro,
  onClose,
  visible,
  onReset,
}: ModalFiltroAuditoriaProps) {
  const [localFiltro, setLocalFiltro] =
    useState<Partial<RelatorioAuditoriaQueryParams>>(filtro);
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      destroyOnClose
      closable={false}
      className="antd-custom-header"
      width="600px"
      title={<Toolbar title="Filtros" onClose={onClose} border="0px" />}
      footer={
        <Flex
          justifyContent="end"
          align="center"
          gap="8px"
          alignContent="center"
          alignItems="center"
        >
          <CloseModalButton
            closeModalLabel="Fechar"
            close={onClose}
            mt="32px"
          />
          <FooterModal
            showBorderTop={false}
            isDisabled={false}
            onSubmit={() => {
              onChangeFiltro(localFiltro);
              onClose();
            }}
            onClose={() => {
              onReset();
              setLocalFiltro(defaultFiltroRelatorioAuditoria);
              onClose();
            }}
            showRegisterAnother={false}
            primaryButtonText={`Filtrar`}
            buttonCancelarText="Limpar filtros"
            isLoadingSave={false}
          />
        </Flex>
      }
    >
      <Box as={Row} gutter={16} mb={4}>
        <Col md={24}>
          <Text mb="2px" fontSize="13px">
            Período
          </Text>
          <DateRangePicker
            allowEmptyDates={{
              dataInicio: false,
              dataFim: false,
            }}
            maxRangeDays={90}
            onChange={(dataInicio, dataFim) => {
              setLocalFiltro((state) => ({ ...state, dataInicio, dataFim }));
            }}
            value={{
              dataInicio: localFiltro.dataInicio,
              dataFim: localFiltro.dataFim,
            }}
          />
        </Col>
      </Box>
      <Box as={Row} gutter={16} mb={4}>
        <Col xs={24}>
          <Text mb="2px" fontSize="13px">
            Clientes
          </Text>
          <SelectTenant
            mode="multiple"
            onChange={(tenantsIds) => {
              setLocalFiltro((state) => ({
                ...state,
                tenantsIds,
              }));
            }}
            value={localFiltro.tenantsIds}
          />
        </Col>
      </Box>
      <Box as={Row} gutter={16} mb={4}>
        <Col xs={24}>
          <Text mb="2px" fontSize="13px">
            Autor
          </Text>
          <SelectUsuarioResponsavel
            value={localFiltro.usuarioId}
            onChange={(usuarioId) => {
              setLocalFiltro((state) => ({ ...state, usuarioId }));
            }}
          />
        </Col>
      </Box>
    </Modal>
  );
}
